import { useEffect, useState } from "react";
import debounce from "lodash/debounce";

import {
  screens,
  type TailwindBreakpoints,
} from "@vega-core/themeConfig/screens";

export type { TailwindBreakpoints };

export function useDeviceWidth(breakpoint: TailwindBreakpoints): boolean {
  const [windowWidth, setWindowWidth] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth : 0,
  );

  useEffect(() => {
    const debouncedHandleResize = debounce(() => {
      setWindowWidth(window.innerWidth || 0);
    }, 250);

    window.addEventListener("resize", debouncedHandleResize);

    debouncedHandleResize();

    return () => {
      window.removeEventListener("resize", debouncedHandleResize);
      debouncedHandleResize.cancel();
    };
  }, []);

  const breakpointValue = parseInt(screens[breakpoint], 10);

  return windowWidth >= breakpointValue;
}
